import styled from '@emotion/styled';
import { css } from '@emotion/react';

import { startDirection } from 'app/styles/selectors/markup';

const S = {};

const fieldTransition = '0.2s cubic-bezier(0.5, 0, 0.25, 1)';

S.Field = styled.div`
  label: Field;
  padding: 1.5rem 0 0;
  position: relative;
  width: 100%;
  height: 3.75rem;
  border-bottom: 0.125rem solid
    ${({ isFocused }) =>
      isFocused ? 'var(--colors-orange-base)' : 'var(--colors-silver)'};

  ${({ isDirty, isFocused }) =>
    (isDirty || isFocused) &&
    css`
      ${S.Field.Description} {
        transform: scale(0.66) translateY(-1rem);
      }
    `}

  ${({ isError }) =>
    isError &&
    css`
      border-color: var(--colors-pomegranate);
      ${S.Field.Description} {
        color: var(--colors-pomegranate);
      }
    `}
`;

S.Field.Description = styled.label`
  label: Description;
  position: absolute;
  z-index: var(--z-index-under-background);
  color: var(--colors-silver-chalice);
  top: 1.15rem;
  ${startDirection}: 0;
  transform-origin: top ${startDirection};
  transition: transform ${fieldTransition};
`;

S.Field.Input = styled.input`
  label: Input;
  padding: 0.25rem 0;
  width: 100%;
  height: 100%;
  background-color: transparent;
  display: block;
  border: none;
  transition: border-color ${fieldTransition};
  overflow: hidden;

  &:invalid {
    box-shadow: none;
  }
`;

export default S;
